import React from "react";
import { Eye } from "lucide-react";
import { Button } from "./Button";

interface ViewWebsiteButtonProps {
  subdomain: string;
  className?: string;
  label?: string;
}

const ViewWebsiteButton: React.FC<ViewWebsiteButtonProps> = ({
  subdomain,
  className = "",
  label = "View Website",
}) => {
  if (!subdomain) return null;

  return (
    <a
      href={`https://${subdomain}.salonify.co.uk`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button
        className={`bg-[#885ABB] hover:bg-[#7748A4] text-white px-3 py-1.5 lg:px-5 lg:py-2 text-[10px] lg:text-xs font-medium shadow-sm hover:shadow-md transition-all duration-200 flex items-center gap-1.5 lg:gap-2 ${className}`}
      >
        <Eye className="w-3 h-3 lg:w-3.5 lg:h-3.5" />
        {label}
      </Button>
    </a>
  );
};

export default ViewWebsiteButton;
